import {CREATE_SCHOOL_COMPANY} from "./../../routes";
import {ICreateAndUpdateSchool} from "../../../types/school.interface";
import customAxios from "../../customAxios";
import utils from "../../../utils";

const createSchoolCompany = async (formData: ICreateAndUpdateSchool) => {
  try {
    return (
      await customAxios.post(CREATE_SCHOOL_COMPANY, {
        ...formData,
        lat        : formData.lat,
        long       : formData.long,
        fullName   : formData.fullName,
        telephone  : formData.telephone,
        phoneNumber: formData.phoneNumber,

        name     : formData.name,
        latitude : formData.lat ,
        longitude: formData.long,

        area        : formData.area        ?._id,
        city        : formData.city        ?._id,
        province    : formData.province    ?._id,
        neighborhood: formData.neighborhood?._id,

        grade: utils.convertSchoolGrade.htmlToMongo(formData.grade),
      })
    ).data;
  } catch (error: unknown) {
    console.error({CREATE_SCHOOL_COMPANY: error});
    return false;
  }
};

export default createSchoolCompany;
